<template>
  <div>
    <body>
      <div class="disable-scroll-x">
        <div
          style="
            background: linear-gradient(
              286.01deg,
              #5bc4ff 7.93%,
              #0085ff 96.74%
            );
          "
        >
          <CRow class="ml-5 mr-5" style="width: -webkit-fill-available">
            <Mainlayout></Mainlayout>

            <CCol sm="12" class="mt-5">
              <br /><br />
              <br /><br />
              <CContainer>
                <CCard>
                  <CCardHeader>
                    <slot name="header">
                     List Package
                    </slot>
                  </CCardHeader>
                    <CDataTable
                      :hover="hover"
                      :striped="striped"
                      :bordered="bordered"
                      :small="small"
                      :fixed="fixed"
                      :items="FilteredPlan"
                      :fields="fieldsPackage"
                      :items-per-page="small ? 10 : 5"
                      :dark="dark"
                      pagination
                    >
                      <template #Id="{ item }">
                        <td>{{ item.Id }}</td>
                      </template>

                      <template #PackageName="{ item }">
                        <td>
                          <h6
                            style="color: #1e109c; font-size: 12px"
                            class="text-uppercase"
                          >
                            {{ item.PackageName }}
                          </h6>

                          <br />
                        </td>
                      </template>
                      <template #Type="{ item }">
                        <td>
                          <div class="small text-muted">
                            <CBadge
                              color="warning"
                              class="ml-auto"
                              v-if="item.Type === '1'"
                              >Monthly</CBadge
                            >
                            <CBadge color="info" class="ml-auto" v-else>
                              Yearly
                            </CBadge>
                          </div>
                        </td>
                      </template>
                      <template #Price="{ item }">
                        <td>
                          <h6
                            style="color: #1e109c; font-size: 12px"
                            class="text-uppercase"
                          >
                          RM  {{ item.PricePackage }}
                          </h6>

                          <br />
                        </td>
                      </template>
                      <template #Offer="{ item }">
                        <td>
                          <h6
                            style="color: #1e109c; font-size: 12px"
                            class="text-uppercase"
                          >
                            {{ item.OfferName }}
                          </h6>
                          <CBadge
                              color="success"
                              class="ml-auto"
                              v-if="item.DiscountPercentage > 0"
                              >{{ item.DiscountPercentage }} % OFF</CBadge
                            >
                        </td>
                      </template>
                      <template #Action="{ item }">
            <td>
             <CIcon name="cil-pencil" @click="GoToEdit(item)"/> Edit
            </td>
          </template>
                    </CDataTable>
                </CCard>
              </CContainer>
            </CCol>
          </CRow>
        </div>

        <Footerlayout></Footerlayout>
      </div>
    </body>
  </div>
</template>
    
    
    
    
    <script>
import Vue from "vue";
import VueMeta from "vue-meta";

Vue.use(VueMeta);
import AnimatedNumber from "animated-number-vue";
import backgroundUrl from "../assets/img/bg3.png";

// import Translator from "vue-gtranslate";
// import "vue-gtranslate/translator.css";

Vue.use(require("vue-moment"));
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";

import Mainlayout from "../containers/AllHeaderLanding.vue";
import Footerlayout from "../containers/TheFooter.vue";

import VueAgile from "vue-agile";
Vue.use(VueAgile);

// in component

import AOS from "aos";
import "aos/dist/aos.css";

// Tell Vue to install the plugin.
Vue.use(VuejsDialog);

import VueCal from "vue-cal";
import "vue-cal/dist/vuecal.css";

import _ from "lodash";
import $ from "jquery";
import "hooper/dist/hooper.css";

import MenuIcon from "vue-material-design-icons/Menu.vue";
import { Hooper, Slide, Navigation as HooperNavigation } from "hooper";
new Vue({
  el: "#navbar",

  data() {
    return {
      view: {
        topOfPage: true,
      },
    };
  },
  beforeMount() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      if (window.pageYOffset > 400) {
        if (this.view.topOfPage) {
          this.view.topOfPage = false;
          el.setAttribute(
            "style",
            "background: linear-gradient(286.01deg, rgb(91, 196, 255) 7.93%, rgb(0, 133, 255) 96.74%)"
          );
        }
      } else {
        if (!this.view.topOfPage) this.view.topOfPage = true;
        el.setAttribute(
          "style",
          "background: linear-gradient(286.01deg, rgb(91, 196, 255) 7.93%, rgb(0, 133, 255) 96.74%)"
        );
      }
    },
  },
});
export default {
  metaInfo: {
    title:
      "PickiddoTv - Fast track your study by watching our vast online class video collection",
    meta: [
      {
        property: "og:title",
        content:
          "PickiddoRv - Fast track your study by watching our vast online class video collection",
      },
    ],
    link: [{ rel: "canonical", href: "https://www.pickiddo.com/PickiddoTv" }],
  },
  name: "Login",
  components: {
    Slide,
    VueCal,
    MenuIcon,
    agile: VueAgile,
    Mainlayout,
    AnimatedNumber,
    backgroundUrl,
    Footerlayout,
    Hooper,
    HooperNavigation,
  },
  data() {
    return {
        bordered: "",
      plan: [],
      FilteredPlan: [],
      fieldsPackage: [
        { key: "Id" },
        { key: "PackageName" },
        { key: "Type" },
        { key: "Price" },
        { key: "Offer" },
        { key: "Action" },
      ],
    };
  },
  created() {
    AOS.init();
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
    this.GetListPlan();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  computed: {},

  methods: {
    ReloadButton() {
      window.open("https://www.pickiddo.com/home", "_self");
    },

    onScroll() {
      // Get the current scroll position
      const currentScrollPosition =
        window.pageYOffset || document.documentElement.scrollTop;
      // Because of momentum scrolling on mobiles, we shouldn't continue if it is less than zero
      if (currentScrollPosition < 0) {
        return;
      }
      // Here we determine whether we need to show or hide the navbar
      this.showNavbar = currentScrollPosition < this.lastScrollPosition;
      // Set the current scroll position as the last scroll position
      this.lastScrollPosition = currentScrollPosition;
    },
    handleScroll() {
      if (window.pageYOffset > 1000) {
        if (this.view.topOfPage) {
          this.view.topOfPage = false;
        } else {
          this.view.topOfPage = true;
        }
      }
    },
    async GetListPlan() {
      this.$API
        .get(this.$CheckDetailPackage, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.plan = response.data;
            this.FilteredPlan = this.plan;
          }
        });
    },
  },
};
</script>
        <<style scoped>
    
    @import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
    @import url("https://fonts.googleapis.com/css2?family=Inter:wght@100&family=Montserrat&family=Poppins&display=swap");
        
    .c-header {
      /* background: rgb(23, 77, 124);
      background: linear-gradient(92deg, #174d7c, #1b7682);
      border-bottom: 0.01px solid #1a6783;
      border-bottom: 1px solid #636f83; */
    
      background: transparent;
      border-bottom: 0;
      border-bottom: 0;
      /* color: #fff; */
    }
    .c-app{
      background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
      font-family: 'Montserrat', sans-serif;
    }
    body {
      font-family: "Montserrat", sans-serif;
      background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
    }
    h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6 {
        margin-bottom: 0.5rem;
        font-weight: 500;
        line-height: 1.2;
        font-family: "Montserrat", sans-serif;
    }
    label
    {
      font-family: "Montserrat", sans-serif;
    }
    
    body nav.onScroll {
      box-shadow: 0 0 10px #aaa;
      background-color: rgb(255, 255, 255);
      font-family: 'Montserrat';
    font-style: normal;
    }
    body nav.onScroll ul li {
      color: #10b761;
    }
    body nav ul {
      margin-left: 3em;
      width: 25%;
      display: flex;
      justify-content: space-between;
    }
    body nav ul li {
      cursor: pointer;
      font-weight: 600;
      list-style-type: none;
      color: white;
    }
    body {
        top: 0 !important;
        font-family: 'Montserrat', sans-serif;
    }
    li{
      font-family: 'Montserrat', sans-serif;
    }
    .centered {
      position: absolute;
      top: 40%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    
  .custom-input-text input[type="text"] ::placeholder {
    color: #fff;
  }
  .custom-input-text input[type="text"]::placeholder {
    color: #fff;
  }
  .hooper {
      position: relative;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      width: 100%;
      height: auto;
  }
        </style>